import React, { useEffect, useState, useContext, useMemo, useLayoutEffect } from 'react'
import { getProductDeatil, getProductRelated, getSizeInfo } from '@/service/api'
import { LayoutContext } from '@/components/Context'
import { getIdFromUrl } from '@lib/utils';
import * as styles from './product-pc.module.scss'
import Breadcrumb from '@/modules/productPc/Breadcrumb'
import Preview from '@/modules/productPc/Preview'
import ProductInfo from '@/modules/productPc/ProductInfo'
import  Anchor from '@/modules/productPc/Anchor'
import Details from '@/modules/productPc/Details'
import Merchant from '@/modules/productPc/Merchant'
import Brand from '@/modules/productPc/Brand'
import Size from '@/modules/productPc/Size'
import useCateName from '@/modules/Common/useCateName'
import qrcode from '@images/qrcode-download-app.png';
import qrIcon from '@images/qrcodeicon.png';
import topIcon from '@images/top.png'
import Download from '@modules/Home/Download';
import SEO from './seo'
import tabs from '@/layouts/tabs'

const { Item } = Anchor
const Product = (props) => {
  const productId = props.productContext?.product?.id || getIdFromUrl();
  const { updateHeaderState, updateActiveCategroyIndex,  setHeaderUnderline} = useContext(LayoutContext)
  const [productInfo, setProductInfo] = useState(() => {
    return props.pageContext?.product || {}
  })
  const [merchant, setMerchant] = useState(() => {
    return props.pageContext?.related?.merchant || {}
  })
  const [brand, setBrand] = useState(() => {
    return props.pageContext?.related?.brand || {}
  })
  const [sizeInfo, setSizeInfo] = useState()
  const cateList = useCateName(productInfo.categoryIds)

  const cate = useMemo(() => {
    const list = [...cateList || []] 
    if(productInfo.name) {
      list.push({
        cid: '',
        term: productInfo.nameCN || productInfo.name
      })
    }
    return list
  }, [cateList, productInfo])
  

  useEffect(() => {
    const categoryId = cateList?.[0]?.cid
    if(categoryId) {
      const index = tabs.findIndex(item => item.id && item.id === categoryId)
      updateActiveCategroyIndex(index > -1 ? index : 0)
    }else {
      updateActiveCategroyIndex(0)
    }
    return () => {
      updateActiveCategroyIndex(-1)
    }
  }, [cateList, tabs])

  function handleTop() {
    const html = document.querySelector('html');
    html.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  useEffect(() => {
    setHeaderUnderline(true)
    updateHeaderState('relative')
    return () => {
      updateHeaderState('fixed')
      setHeaderUnderline(false)
    }
  }, [])

  useEffect(() => {
      getProductDeatil(productId).then(res => {
      setProductInfo(res)
      }).catch(err => {})
      getProductRelated(productId).then(res => {
        setMerchant(res.merchant)
        setBrand(res.brand)
      }).catch(err => {})
      getSizeInfo(productId).then(res => {
        setSizeInfo(res)
      }).catch(err => {})
  }, [productId])

  return (
    <section className={`${styles.container} ${props.className || ''}`}>
      <SEO
          title={`${productInfo?.brand}_${productInfo?.nameCN || productInfo?.name} | 别样海外购 bieyangapp.com`}
          keywords={`${productInfo?.brand}_${productInfo?.nameCN || productInfo?.name}`}
          description={`${productInfo?.brand}_${productInfo?.nameCN || productInfo?.name} 别样海外购，欧美直邮 正品保障`}
      />
      <Breadcrumb cate={cate} />
      <div className={styles.info}>
        <Preview images={productInfo.images} />
        <ProductInfo info={productInfo} />
      </div>
      <Anchor>
        <Item title="商品详情">
          <Details product={productInfo} />
        </Item>
        {
          sizeInfo ? (
            <Item title="尺码信息">
              <Size info={sizeInfo}  />
            </Item>
          ): null
        }
        {
          merchant ? (
            <Item title="商家信息">
              <Merchant data={merchant} />
            </Item>
          ): null
        }
        {
          brand ? (
            <Item title="品牌信息">
              <Brand data={brand} />
            </Item>
          ): null
        }
      </Anchor>
      <div className={styles.floatingDownload}>
        <div>
          <Download qrcodeImg={qrcode} amount={'688元'} className={styles.qrCode} />
          <img src={qrIcon} className={styles.qrIcon} />
        </div>
        <img src={topIcon} onClick={handleTop} className={styles.topIcon} />
      </div>
    </section>
  )
}

Product.displayName="Product"

export default Product